import { AstNodeCategory, AstNodeType } from './node';
export class NumberLiteral {
    constructor(token, value) {
        this.token = token;
        this.value = value;
        this.nodeType = AstNodeType.NumberLiteral;
        this.nodeCategory = AstNodeCategory.Expression;
    }
    get Value() {
        return this.value;
    }
    set Value(val) {
        this.value = val;
    }
    tokenLiteral() {
        return this.token.literal;
    }
    toString() {
        return this.token.literal;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTnVtYmVyTGl0ZXJhbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvYXN0L051bWJlckxpdGVyYWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsT0FBTyxFQUFFLGVBQWUsRUFBRSxXQUFXLEVBQWMsTUFBTSxRQUFRLENBQUM7QUFFbEUsTUFBTSxPQUFPLGFBQWE7SUFDdEIsWUFBb0IsS0FBWSxFQUFVLEtBQWE7UUFBbkMsVUFBSyxHQUFMLEtBQUssQ0FBTztRQUFVLFVBQUssR0FBTCxLQUFLLENBQVE7UUFDdkQsYUFBUSxHQUFnQixXQUFXLENBQUMsYUFBYSxDQUFDO1FBQ2xELGlCQUFZLEdBQW9CLGVBQWUsQ0FBQyxVQUFVLENBQUM7SUFGRCxDQUFDO0lBSTNELElBQUksS0FBSztRQUNMLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQztJQUN0QixDQUFDO0lBQ0QsSUFBSSxLQUFLLENBQUMsR0FBRztRQUNULElBQUksQ0FBQyxLQUFLLEdBQUcsR0FBRyxDQUFDO0lBQ3JCLENBQUM7SUFFRCxZQUFZO1FBQ1IsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQztJQUM5QixDQUFDO0lBRUQsUUFBUTtRQUNKLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUM7SUFDOUIsQ0FBQztDQUNKIn0=